"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllOptionsFns = void 0;
var genMonthsArray_1 = require("./genMonthsArray");
var genYearsArray_1 = require("./genYearsArray");
var getLanguagesArray_1 = require("./getLanguagesArray");
var getAllOptionsFns = function (theme) { return (__assign({ genYearsArray: genYearsArray_1.genYearsArray, genMonthsArray: genMonthsArray_1.genMonthsArray, getLanguagesArray: getLanguagesArray_1.getLanguagesArray }, ((theme === null || theme === void 0 ? void 0 : theme.optionsFns) || {}))); };
exports.getAllOptionsFns = getAllOptionsFns;
